/**
 * Splits `a.b[0].c` into `['a', 'b', '0', 'c']`. Empty segments are dropped,
 * so `.a..b` reads the same as `a.b`.
 */
export function pathSegments(path: string): string[] {
  return path
    .replace(/\[(\d+)\]/g, '.$1')
    .split('.')
    .filter(Boolean);
}

/**
 * Reads a dotted, indexed path; `undefined` when any step is missing. Only
 * own properties are followed, so a path such as `constructor.name` or
 * `__proto__.x` never reads inherited values.
 */
export function readOwnPath(root: unknown, path: string): unknown {
  let current: unknown = root;
  for (const segment of pathSegments(path)) {
    if (current === null || typeof current !== 'object') return undefined;
    if (!Object.prototype.hasOwnProperty.call(current, segment)) {
      return undefined;
    }
    current = (current as Record<string, unknown>)[segment];
  }
  return current;
}
